import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

export interface Props {
  open: boolean;
  loading: boolean;
  firstName: string;
  lastName: string;
  userEmail?: string;

  handleFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleLastNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleEditLinkedinAccountName(): void;
}

const EditLinkedinAccountNameDialog: React.FC<Props> = ({
  open,
  loading,
  firstName,
  lastName,
  userEmail,
  handleFirstNameChange,
  handleLastNameChange,
  handleClose,
  handleEditLinkedinAccountName,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'} transitionDuration={0}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('editLinkedinAccountName')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <PaiTextField label={t('userAccount')} value={userEmail || ''} disabled />
          <PaiTextField label={t('firstName')} placeholder={t('enterFirstNameHere')} value={firstName} onChange={handleFirstNameChange} />
          <PaiTextField label={t('lastName')} placeholder={t('enterLastNameHere')} value={lastName} onChange={handleLastNameChange} />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton
          text={t('save')}
          size={'small'}
          border={'rounded'}
          action={handleEditLinkedinAccountName}
          disabled={firstName.trim() === '' || lastName.trim() === ''}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EditLinkedinAccountNameDialog;
